import { BaseDto } from '../../core';
import { PROMOTION_TYPE, FileAttachmentDto } from '../../shared';
import { Product } from '../product';
import dayjs from 'dayjs';

export class ImageUrl {
  marker?: string;
  url?: string;
}

export class Promotion extends BaseDto<Promotion> {
  constructor(partial?: any) {
    super(partial);
  }

  id: number;
  subject: string;
  promotionType: PROMOTION_TYPE;
  language: string;
  isDisplay: boolean;
  started: Date;
  ended: Date;
  pcImage: FileAttachmentDto;
  mobileImage: FileAttachmentDto;
  pcUrl: ImageUrl[];
  mobileUrl: ImageUrl[];
  notice?: string;
  comment: string;
  displayCategoryCode: string;
  products?: Product[];

  pcBannerImage: FileAttachmentDto;
  mobileBannerImage: FileAttachmentDto;

  get dayLeft() {
    return dayjs(this.ended).diff(dayjs(), 'day');
  }
}
